/**
 * Precheck: information about the site before anything renders.
 * @module soapbox/precheck
 */ /** Whether pre-rendered data exists in Mastodon's format. */var hasPrerenderMastodon=Boolean(document.getElementById('initial-state'));/** Whether initial data was loaded into the page by server-side-rendering (SSR). */export var isPrerendered=hasPrerenderMastodon;